import { render, staticRenderFns } from "./ProgramPOABudgetRecap.vue?vue&type=template&id=5810713a"
import script from "./ProgramPOABudgetRecap.vue?vue&type=script&lang=js"
export * from "./ProgramPOABudgetRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports